import Rails from '@rails/ujs';
import '@/flash-messages';

// In vite-ruby example and autogenerated entrypoint Rails UJS is loaded without explicit .start()
// https://github.com/ElMassimo/vite_ruby/blob/main/examples/rails/app/frontend/entrypoints/application.ts
// In contrast, in default rails pack script it is triggered explicitly with .start()
// Leaving it without explicit start works in production, for some reason it does not work in dev.
// And if calling explicitly without any check it throws an error that ujs is already started in production.
// Therefore, this hack:
if (!window._rails_loaded) {
  Rails.start();
}
